import { render, staticRenderFns } from "./SignupTradingOptions.vue?vue&type=template&id=9f25b3a6&scoped=true"
import script from "./SignupTradingOptions.vue?vue&type=script&lang=ts"
export * from "./SignupTradingOptions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f25b3a6",
  null
  
)

export default component.exports